import React from "react";

const tonen = {
  neutraal: { background: "var(--neutraal-100)", color: "var(--text-body)" },
  actie: { background: "var(--actie-zacht)", color: "var(--accent)" },
  positief: { background: "var(--positief-zacht)", color: "var(--text-positief)" },
  aandacht: { background: "var(--aandacht-zacht)", color: "var(--text-aandacht)" },
  alarm: { background: "var(--alarm-zacht)", color: "var(--text-alarm)" },
  inkt: { background: "var(--ink)", color: "var(--text-inverse)" },
};

export function Badge({ tone = "neutraal", pill = false, style, children, ...rest }) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "var(--ruimte-2)",
      padding: "2px var(--ruimte-4)", borderRadius: pill ? "var(--radius-pil)" : "var(--radius)",
      font: "var(--text-label)", fontSize: "var(--fs-xs)", ...tonen[tone], ...style }} {...rest}>{children}</span>
  );
}
